import { startTransition as reactStartTransition } from "react";
const startTransition = callback => {
  reactStartTransition(callback);
};
export { startTransition };
//# sourceMappingURL=index.mjs.map
